/**
 * Generic, app-agnostic analytics events shared across Spirii apps.
 *
 * Naming follows Mixpanel's tracking-strategy guidance: snake_case,
 * object_action structure, no abbreviations, and one event with properties over
 * many narrow events.
 * https://docs.mixpanel.com/guides/strategic-playbooks/onboarding-playbook/plan/tracking-strategy
 *
 * App-specific events (e.g. booking, charge-map) should be composed on top of
 * this object in the app's own config:
 *
 * @example
 * const ANALYTICS_EVENTS = {
 *   ...SHARED_ANALYTICS_EVENTS,
 *   BOOKING_REQUEST: "booking_request",
 * } as const;
 */
const ANALYTICS_EVENTS = {
  // Feature flag exposure (LaunchDarkly integration).
  // https://docs.mixpanel.com/docs/tracking-methods/integrations/launchdarkly
  FEATURE_FLAG_EXPOSURE: "$experiment_started",

  // Form lifecycle.
  FORM_START: "form_start",
  FORM_COMPLETE: "form_complete",
  FORM_ERROR: "form_error",
  FORM_ABANDON: "form_abandon",
} as const;

type AnalyticsEvent = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export { ANALYTICS_EVENTS };
export type { AnalyticsEvent };
